import { isValid, parseISO } from "date-fns";
import { now } from "./now";
import { DATE_PLACEHOLDER } from "../constants";

/**
 * Parses a time string (HH:mm format) into a Date object using a placeholder date.
 * If the time string is invalid, returns the current time.
 *
 * @param timeString - Time string in HH:mm format (e.g., "14:30")
 * @returns Date object with the time set to the provided time
 */
export const parseTime = (timeString: string | null | undefined): Date => {
  if (!timeString) {
    return now();
  }

  try {
    const dateWithTime = parseISO(`${DATE_PLACEHOLDER}T${timeString}`);

    if (!isValid(dateWithTime)) {
      return now();
    }

    return dateWithTime;
  } catch {
    return now();
  }
};
